// component

import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { Link, Navigate, useNavigate } from "react-router-dom";
import classnames from "classnames";
import { serialize } from "v8";
import LoadingIconWithText from "components/LoadingIconWithText";
import { changeSelectedContentTitle } from "../../../redux/actions";
import { useEffect } from "react";
import { getWebUserId } from "api";
import { Const } from "const";
import { Utils } from "helpers/utils";

interface CustomerContentTitleProps {
    contentTitles: Array<any>
}





// const unRead: number = 12;
const isActive = false;
const isOnline = true;

const CustomerContentTitle = ({ contentTitles }: CustomerContentTitleProps) => {

    const navigate = useNavigate();
    const { dispatch, useAppSelector } = useRedux();
    const selectorData = createSelector(
        // (state: any) => state.Login,
        (state: any) => state.Profile2,
        (/*login,*/ profile2) => ({
            // isUserLogin: login.isUserLogin,
            // error: login.error,
            // loginLoading: login.loading,
            // isUserLogout: login.isUserLogout,

            // logonUserName: profile2.userName,
            // profile2: profile2,
            activeGroupId: profile2.activeGroupId,
            webUserId: profile2.webUserId,
            customerIsCdSys: profile2.customerIsCdSys,
        })
    );
    const { activeGroupId, webUserId, customerIsCdSys } = useAppSelector(selectorData);


    // console.log('contentTitles:', contentTitles);
    const onTitleClick = async (event: any, title: any) => {
        // console.log('const onTitleClick = async (title: any) => {:', title);
        if (title.canOpen) {
            if (title.contentMode == 'OpenLink') {
                const link = title.contentLink;
                const newLink = await Utils.GetExternalUrl('Title Click', link, webUserId, customerIsCdSys);
                if (event.ctrlKey) {
                    window.open(newLink /*title.keyUrl*/, '_blank'); // Open in new tab if Ctrl is held
                } else {
                    window.location.href = newLink;// title.contentLink;
                }
            } else {
                dispatch(changeSelectedContentTitle(activeGroupId, title.contentTitleId, 'onTitleClick', title.contentMode));
            }
        } else {
            alert(Const.NO_PERMISSION_ON_DCONNECT);
            dispatch(changeSelectedContentTitle(activeGroupId, null, 'onTitleClick', null));
        }

        // const webUserId = await getWebUserId(activeGroupId);
        // if (webUserId && webUserId != Const.NON_WEB_USER_ID) {
        //     if (title.contentMode == 'OpenLink') {
        //         window.location.href = title.contentLink;
        //     } else {
        //         dispatch(changeSelectedContentTitle(activeGroupId, title.contentTitleId));
        //     }
        // }else{
        //     alert(Const.NO_PERMISSION_ON_DCONNECT);
        //     dispatch(changeSelectedContentTitle(activeGroupId, null));
        // }
    }

    useEffect(() => {
        try {
            // When click open external URL and return back to to PWA, PWA will refresh it. Detect this and go to last title
            const lastActiveTitle = localStorage.getItem("lastActiveTitle");
            if (lastActiveTitle) {
                const json = JSON.parse(lastActiveTitle);
                const now = new Date();
                if (json && json.activeGroupId && json.selectedContentTitle && now < json.expire) {
                    dispatch(changeSelectedContentTitle(activeGroupId, json.selectedContentTitle, 'lastActiveTitle', json.selectedContentTitleMode));
                }
                localStorage.removeItem("lastActiveTitle");
            }
        } catch (e) {
            console.error(e);
        }
    }, []);

    return (
        <>

            {(contentTitles || []).map((title: any, key: number) => (
                <li key={key} className={classnames("", { active: isActive })} onClick={(e) => onTitleClick(e, title)}>
                    <Link to="#" className={classnames({ "unread-msg-user": title.statusText != "", "disabled": !title.canOpen })}>
                        <div className="d-flex align-items-center">
                            <div
                                className={classnames(
                                    "chat-user-img",
                                    "align-self-center",
                                    "me-2",
                                    "ms-0",
                                    { online: isOnline }
                                )}
                            >
                                <div className="avatar-xs avatar-xs-content-title">
                                    <i className={title.titlePictureUrl} style={{ fontSize: "20pt" }}></i>
                                </div>
                            </div>

                            <div className="overflow-hidden">
                                <p className="text-truncate mb-0">{title.titleName}</p>
                            </div>

                            {title.displayUnread && (
                                <div className="ms-auto">
                                    {title.statusText == "-1" && (
                                        <LoadingIconWithText loadingText={""} />
                                    )}
                                    {title.statusText != "-1" && title.statusText != "" && (
                                        <span className={classnames("badge unread-span rounded p-1", { "disabled": !title.canOpen })}>
                                            {title.statusText}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    </Link>
                </li>
            ))}


        </>
    );
};

export default CustomerContentTitle;
